import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getCookie } from "components/common/cookie";

const initialState = {
  myPosts: [],
  myComments: [], // 댓글,대댓글
  loadMyFeedLoading: false,
  loadMyFeedDone: false,
  loadMyFeedError: null,
};

const token = {
  Authorization: `Bearer ${getCookie("AccessToken")}`,
};

const loadMyFeed = createAsyncThunk("myPage/loadMyFeed", async () => {
  const config = {
    headers: token,
  };

  try {
    const { data } = await axios.get(
      `https://node.floway.co.kr/users/feed`,
      config,
    );
    return data;
  } catch (err) {
    return err.response.data;
  }
});

const userFeedSlice = createSlice({
  name: "myPage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // loadMyFeed
    builder
      .addCase(loadMyFeed.pending, (state) => {
        state.loadMyFeedLoading = true;
      })
      .addCase(loadMyFeed.fulfilled, (state, action) => {
        state.loadMyFeedLoading = false;
        state.loadMyFeedDone = true;

        state.myPosts = action.payload.boards;
        state.myComments = action.payload.comments;
      })
      .addCase(loadMyFeed.rejected, (state) => {
        state.loadMyFeedLoading = false;
        state.loadMyFeedError = true;
      });
  },
});

export { loadMyFeed };

export default userFeedSlice.reducer;
